var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-scrollbar__wrap wrap-white" }, [
    _c(
      "div",
      { staticClass: "el-scrollbar__view" },
      [
        _c("div", {
          staticStyle: {
            width: "100%",
            height: "800px",
            border: "#ccc solid 1px",
          },
          attrs: { id: "dituContent" },
        }),
        _c(
          "el-dialog",
          {
            directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
            attrs: { title: _vm.title, visible: _vm.dialogTableVisible },
            on: {
              "update:visible": function ($event) {
                _vm.dialogTableVisible = $event
              },
            },
          },
          [
            _vm.index === 1
              ? _c("img", {
                  attrs: {
                    width: "500px",
                    height: "300px",
                    src: require("@/assets/img/zjs.png"),
                  },
                })
              : _vm._e(),
            _vm.index === 2
              ? _c("img", {
                  attrs: {
                    width: "500px",
                    height: "300px",
                    src: require("@/assets/img/xwh.png"),
                  },
                })
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }